import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { DialogCloseModule } from 'src/app/shared/components/dialog-close/dialog-close.module';
import { DialogSaveCloseModule } from 'src/app/shared/components/dialog-save-close/dialog-save-close.module';
import { DynamicFormModule } from 'src/app/shared/components/dynamic-form/dynamic-form.module';
import { FieldsModule } from 'src/app/shared/components/fields/fields.module';
import { TableResponsiveModule } from 'src/app/shared/components/table-responsive/table-responsive.module';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';
import { PlanService } from '../plans/crud-service';
import { PlansModule } from '../plans/plans.module';
import { LayoutCrudIndexModule } from '../shared/layout-crud-index/layout-crud-index.module';
import { SystemService } from '../systems/crud-service';
import { CustomerCESComponent } from './crud-ces/crud-ces.component';
import { CustomerService } from './crud-service';
import { CustomerPlanItemCancelReasonDialogModule } from './customer-plan-items/customer-plan-item-cancel-reason-dialog/customer-plan-item-cancel-reason-dialog.module';
import { CustomerPlanItemEditReasonDialogModule } from './customer-plan-items/customer-plan-item-edit-reason-dialog/customer-plan-item-edit-reason-dialog.module';
import { CustomerPlanItemsComponent } from './customer-plan-items/customer-plan-items.component';
import { CustomerPlansSystemModulesModule } from './customer-plan-items/customer-plans-system-modules/customer-plans-system-modules.module';
import { SystemModuleSelectModule } from './customer-plan-items/system-modules-select/system-module-select.module';
import { CustomersRoutingModule } from './customers-routing.module';
import { TableExtensibleModule } from 'src/app/shared/components/table-extensible/table-extensible.module';
import { CustomerParcelModule } from '../shared/generate-parcels/generate-parcels.module';
import { CustomerTableModule } from './crud-index/customer-table/customer-table.module';
import { CustomerPlanItemsSelectComponent } from './customer-plan-items/customer-plan-items-select.component';
import { CustomerToUpdatePlansModule } from './crud-index/customer-to-update-plans/customer-to-update-plans.module';
import { ComponentOptionsComponent } from './component-options/component-options.component';
import {
  CustomerCrudIndex,
  CustomerIndexComponent,
  CustomerIndexSelectComponent,
  CustomerIndexMultiSelectComponent
} from './crud-index';
import { AccountDashboardService } from '../accounts-dashboard/account-dashboard.service';
import { ReportPreviewComponent } from './crud-index/report-preview/report-preview.component';
import { CustomerContractsPanelComponent } from './customer-contracts-panel/customer-contracts-panel.component';
import { CustomerOsListComponent } from './customer-os-list/customer-os-list.component';
import { CustomerBranchesPanelComponent } from './customer-branches-panel/customer-branches-panel.component';
import { CustomerBranchDialogComponent } from './customer-branch-dialog/customer-branch-dialog.component';
import { CustomerResponsiblesPanelComponent } from './customer-responsibles-panel/customer-responsibles-panel.component';
import { CustomerResponsibleDialogComponent } from './customer-responsible-dialog/customer-responsible-dialog.component';
import { CustomerAccessesPanelComponent } from './customer-accesses-panel/customer-accesses-panel.component';
import { CustomerChargesPanelComponent } from './customer-charges-panel/customer-charges-panel.component';
import { CustomerFiscalParametersPanelComponent } from './customer-fiscal-parameters-panel/customer-fiscal-parameters-panel.component';
import { ContractsListDialogModule } from '../contracts/components/contract-dialog/contract-list-modal/contracts-list-dialog.module';
import { ServiceOrderService } from '../service-orders/crud-service';

@NgModule({
  declarations: [
    CustomerCESComponent,
    CustomerPlanItemsComponent,
    CustomerPlanItemsSelectComponent,
    ComponentOptionsComponent,
    CustomerIndexComponent,
    CustomerIndexSelectComponent,
    CustomerIndexMultiSelectComponent,
    ReportPreviewComponent,
    CustomerContractsPanelComponent,
    CustomerOsListComponent,
    CustomerBranchesPanelComponent,
    CustomerBranchDialogComponent,
    CustomerResponsiblesPanelComponent,
    CustomerResponsibleDialogComponent,
    CustomerAccessesPanelComponent,
    CustomerChargesPanelComponent,
    CustomerFiscalParametersPanelComponent,
  ],
  imports: [
    CommonModule,
    CustomersRoutingModule,
    AngularMaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    DynamicFormModule,
    FieldsModule,
    TableResponsiveModule,
    DialogCloseModule,
    DialogSaveCloseModule,
    DialogContainerModule,
    LayoutCrudIndexModule,
    SystemModuleSelectModule,
    CustomerPlansSystemModulesModule,
    CustomerPlanItemCancelReasonDialogModule,
    CustomerPlanItemEditReasonDialogModule,
    TableExtensibleModule,
    CustomerParcelModule,
    CustomerTableModule,
    CustomerToUpdatePlansModule,
    PlansModule,
    ContractsListDialogModule,
  ],
  providers: [CustomerService, SystemService, PlanService, CustomerCrudIndex, AccountDashboardService, ServiceOrderService],
  exports: [
    CustomerIndexSelectComponent
  ]
})
export class CustomersModule { }
